module.exports = __webpack_public_path__ + "img/step01_a_stand_basic_remove_film_cut_straps.898d5ffa.jpg";